import React from 'react';

import { browserHistory, Router } from 'react-router';

import { ApolloClient, createNetworkInterface, ApolloProvider } from 'react-apollo';
import { render, unmountComponentAtNode } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { syncHistoryWithStore } from 'react-router-redux';

import configureStore from 'state/store';

const root = document.querySelector('#root');

// eslint-disable-next-line no-underscore-dangle
const preloadedState = window.__PRELOADED_STATE__;

// Create a GraphQL client
const graphqlEndpoint = `${GRAPHQL_PROTOCOL}://${GRAPHQL_HOST}/graphql`;
const apolloClient = new ApolloClient({
  networkInterface: createNetworkInterface({
    uri: graphqlEndpoint,
  }),
});

// Hydrate the store on the client
const store = configureStore(apolloClient, preloadedState);

// Create an enhanced history that syncs navigation events with the store
const history = syncHistoryWithStore(browserHistory, store);

// Include DevTools but only in non-production environments
const isProduction = process.env.NODE_ENV === 'production';
const noComponent = _ => null;
const DevTools = isProduction ? noComponent : require('state/containers/DevTools').default;

const mount = () => {
  // eslint-disable-next-line global-require,import/newline-after-import
  const routes = require('routes').default;

  render(
    <AppContainer>
      <ApolloProvider client={apolloClient} store={store}>
        <div>
          <Router routes={routes} history={history} />
          <DevTools />
        </div>
      </ApolloProvider>
    </AppContainer>,
    root
  );
};

mount();

// Enable the React debugger in the console after the first mount
window.React = React;

if (!isProduction) {
  /**
   * This adds the Perf addons to the global window so you can debug
   * the performance from within your console
   */
  // eslint-disable-next-line global-require
  window.Perf = require('react-addons-perf');

  if (module.hot) {
    module.hot.accept('routes', () => {
      unmountComponentAtNode(root);
      mount();
    });
  }
}



// WEBPACK FOOTER //
// ./src/client/index.js